import * as React from "react";
import { compose } from "recompose";

import {ChooseGroupPageComponent} from "./ChooseGroup/ChooseGroupPage";
import {PageProperties} from "../../shared/components/PageWithHeader/PageProperties";
import {BreadcrumbInitializer} from "../../shared/components/Breadcrumbs/BreadcrumbsInitializer";
import {PageArticle} from "../../shared/components/PageWithHeader/PageArticle";
import {PageBreadcrumb} from "../../shared/components/PageWithHeader/PageProperties";

export class TouchstoneHelpPageComponent extends React.Component<PageProperties<undefined>> {

    static title: string = "Touchstones Help";

    componentDidMount(){
        this.props.createBreadcrumbs(TouchstoneHelpPageComponent.breadcrumb());
    }

    static breadcrumb() : PageBreadcrumb {
        return {
            name: TouchstoneHelpPageComponent.title,
            urlFragment: "help/touchstones/",
            parent: ChooseGroupPageComponent.breadcrumb()
        }
    }

    render(): JSX.Element {
        return <PageArticle title={TouchstoneHelpPageComponent.title}>
            <p>
                To distinguish between the different sets of impact estimates
                generated by the consortium over time, we use the concept of the
                'touchstone', which uniquely defines the version in terms of model
                version and associated assumptions as well as input datasets, in
                particular regarding vaccination coverage.
            </p>
            <span>
                There are two types of touchstones:
                <ol>
                    <li>
                        Touchstones containing 'native' model runs, as supplied by the
                        modelling groups. These are the ones directly generated by consortium
                        members.
                    </li>
                    <li>
                        Touchstones containing 'modified updates' of the native runs,
                        updating estimates between the major re-runs with new assumptions
                        regarding vaccination coverage. Modified updates are performed by the
                        consortium's secretariat without input from consortium members.
                    </li>
                </ol>
            </span>
            <div className="subSectionTitle">Touchstone naming conventions</div>
            <p>
                Touchstones are named by the date when they were generated (format
                yyyymm), and a text string determining the assumptions of the
                underlying vaccination coverage set ('gavi' for using Gavi's SDF
                projections, 'wue' when WUENIC estimates of past vaccination coverage
                are used (together with Gavi's records of past campaigns that have
                been performed).
            </p>
            <p>
                Native touchstones will only have one part to their name, and will
                usually be based on Gavi's coverage projections. The upcoming
                touchstone for the 2017 run of impact estimates will be '201710gavi',
                while we currently ask you to generate estimates associated with the
                test runs that are part of the touchstone '201708test'.
            </p>
            <p>
                Modified updates will be labelled with the same name as the native
                touchstone which estimates are updated, followed by a second part
                determining the vaccination coverage used in the update. For instance,
                the touchstone '201510gavi-201707wue' refers to the last set of impact
                estimates generated in autumn 2015 based on SDF12, updated with the
                new WUENIC coverage published in July 2017.
            </p>
        </PageArticle>;
    }
}

export const TouchstoneHelpPage = compose(BreadcrumbInitializer)(TouchstoneHelpPageComponent) as
    React.ComponentClass<Partial<PageProperties<undefined>>>;
